/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* SAP HANA specific restore properties for point-in-time database recovery. When provided, Eon will restore the VM to the specified recovery timestamp by first restoring from the most recent full VM snapshot before that time, then executing the HANA backint recovery process to replay logs. 
*/
export class SapHanaRestoreProperties {
  /**
  * ISO 8601 timestamp specifying the point-in-time to recover to. Eon will find the last full VM snapshot before this timestamp and recover the HANA database to this exact point in time. 
  */
  'recoveryTimestamp': Date;
  /**
  * HANA database password for the recovery operation.
  */
  'hanaDbPassword': string;
  /**
  * HANA database port number.
  */
  'hanaPort'?: number;
  /**
  * Optional HANA System ID (SID). If not provided, the default SID from the backup will be used. 
  */
  'hanaSid'?: string;
  /**
  * Optional HANA instance number. If not provided, the default instance number from the backup will be used. 
  */
  'hanaInstanceNumber'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "recoveryTimestamp",
      "baseName": "recoveryTimestamp",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "hanaDbPassword",
      "baseName": "hanaDbPassword",
      "type": "string",
      "format": "password"
    },
    {
      "name": "hanaPort",
      "baseName": "hanaPort",
      "type": "number",
      "format": ""
    },
    {
      "name": "hanaSid",
      "baseName": "hanaSid",
      "type": "string",
      "format": ""
    },
    {
      "name": "hanaInstanceNumber",
      "baseName": "hanaInstanceNumber",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SapHanaRestoreProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

